import { IMetaData, IMetaUrl, IPageModelContent } from 'interfaces/pages';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useQueryParameters } from 'hooks/useQueryString';
import { useParams } from 'react-router-dom';
import { BuildAndPriceParms } from 'interfaces/buildAndPrice';
import { useDispatch } from 'react-redux';
import { setBapAvailableQueries } from 'redux/slices/metadataSlice';

export interface IMetadataProps {
  metadata: IMetaData[];
  canonicalUrls: IMetaUrl[];
  pageModelContent: IPageModelContent;
}

const Metadata = (props: IMetadataProps): JSX.Element => {
  const dispatch = useDispatch();
  const queryParameters = useQueryParameters();
  const modelYearQS = queryParameters.get('modelyear');
  const modelSeriesQS = (
    queryParameters.get('vehiclemodelseries') ||
    queryParameters.get('modelseries')
  )?.toLocaleLowerCase();
  const { vehicleModelSeries } = useParams<BuildAndPriceParms>();
  const fullPath = window.location.pathname + window.location.search;

  const modelName =
    modelSeriesQS?.toLocaleLowerCase() ||
    vehicleModelSeries?.toLocaleLowerCase();

  const { metadata, canonicalUrls } = props;

  const foundMetadata: IMetaData | undefined =
    modelYearQS && modelName
      ? metadata.find(
          (meta) =>
            meta.modelName?.toLocaleLowerCase() === modelName &&
            meta.modelYear?.toString() === modelYearQS
        )
      : metadata.length > 0
      ? metadata[0]
      : undefined;

  useEffect(() => {
    if (props.pageModelContent?.years) {
      const availableYears = Object.keys(props.pageModelContent.years);
      const availableModels = new Set();
      const availableModelIds = new Set();

      availableYears.forEach((year) => {
        props.pageModelContent.years[year].forEach((entry) => {
          const modelKey = Object.keys(entry)[0];
          availableModels.add(modelKey.toLowerCase());

          const modelData = entry[modelKey];
          if (modelData.modelIDs) {
            modelData.modelIDs.forEach((id) => availableModelIds.add(id));
          }
        });
      });

      const years = availableYears;
      const models = Array.from(availableModels) as string[];
      const modelIds = Array.from(availableModelIds) as string[];

      dispatch(
        setBapAvailableQueries({
          years: years,
          models: models,
          modelIds: modelIds,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  if (foundMetadata) {
    return (
      <Helmet>
        {foundMetadata.title && <title>{foundMetadata.title}</title>}
        {foundMetadata.description && (
          <meta name="description" content={foundMetadata.description} />
        )}
        {foundMetadata.keywords && (
          <meta name="keywords" content={foundMetadata.keywords} />
        )}
        {canonicalUrls.length &&
          canonicalUrls.map((url: IMetaUrl) => (
            <link
              key={`canonUrl${url.url}`}
              rel={url.type}
              href={`${url.url}${fullPath}`}
              hrefLang={url.language}
            />
          ))}
      </Helmet>
    );
  }
  return <> </>;
};

export default Metadata;
